<template>
  <div>
    <Loading :show="loading" />
    <div>
      <div :class="{disabled: loading, 'max-width': true}">

        <h1>Översättningar</h1>

        <button @click="generateTranslations()">Skapa översättningar</button>
        <button @click="generateTranslationsFromFiles()">Skapa översättningar utifrån befintliga översättningar</button>

        <br /><br />
        <hr />
        <br /><br />

        <button @click="getFile('en')">Hämta engelsk fil</button>
        <button @click="getFile('da')">Hämta dansk fil</button>

        <br /><br />
        <hr />
        <br /><br />

        <input type="file" id="file" name="file" />

        <br /><br />

        <button @click="uploadFile()">Ladda upp fil</button>


      </div>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      settings: [],
      loading: false,
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    async generateTranslations() {
      this.loading = true;
      await API.get('/admin/translations?lang=sv');
      this.loading = false;
    },
    async generateTranslationsFromFiles() {
      this.loading = true;
      await API.get('/admin/translations?lang=sv&from-files=1');
      this.loading = false;
    },
    getFile(lang) {
      const url = API.getUrl(`/admin/translations-excel?lang=${lang}`);
      this.download(url);
    },
    async uploadFile() {
      const file = document.querySelector('#file');

      if (!file.files.length) {
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append('file', file.files[0]);

      await API.postFile('/admin/translations-update', formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.max-width
  max-width: 600px
  margin 20px auto
</style>



// WEBPACK FOOTER //
// Translation.vue?73d6c880